import * as z from 'zod/mini'
import { emailField } from '../../schemas/common'
import { entityFields } from '../../schemas/entity'

const addressText = z.string().check(z.trim(), z.maxLength(255))

/** An admin creates a premise for an existing, activated user who does not own one yet (`userEmail`). */
export const createEntityBody = z.object({
  userEmail: emailField,
  email: emailField,
  name: entityFields.name,
  addressLine1: addressText,
  zip: addressText,
  city: addressText,
  state: addressText,
  timezone: entityFields.timezone,
  description: entityFields.description,
  phone: entityFields.phone,
})
export type CreateEntityBody = z.infer<typeof createEntityBody>
